import type { ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'

import { AiPageFrame } from '#/modules/ai/back-office/ai-section-layout/ai-page-frame.tsx'
import { RowsSkeleton } from '#/modules/ai/back-office/ai-section-layout/rows-skeleton.tsx'

export function RulesPageSkeleton(): ReactElement {
  const translate = useTranslate()
  return (
    <AiPageFrame
      title={translate('backoffice_ai_rules_page_title')}
      subtitle={translate('backoffice_ai_rules_page_subtitle')}
    >
      <RowsSkeleton rows={4} />
    </AiPageFrame>
  )
}
